export default "__VITE_ASSET__c7ZVGfHb__"